
import { useState, useEffect } from "react";

import input_check from "../input_check.png";
import input_error from "../input_error.png";


function InputDate(props)
{

    
    
    
    const [val, setVal] = useState(props.value);
    const [req, setRequired] = useState(props.req); 
    const [cn, setClassName] = useState('');


    const [onShow,setOnShow] = useState(false);
   

    const checkAndChange = (e) =>
    {
        var v = e.target.value;

 


        setVal(v);

        var correct = true;

        if(req == '1' && v.length < 1) correct = false;         
    
      
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }

        if(props.valChange != null && props.valChange != undefined)
        {
            props.valChange(props.name, v, correct,'');
        }else
        {
            console.log('No support for valChange');
        }    
    }

    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
               if(props.goNext != null && props.goNext != undefined)
               {
                  props.goNext();
               }
          } 
    }

 

    if(cn.length < 2)
    {
        var correct = true;
        
        if(req == '1' && val != undefined && val != null &&  val.length < 1) correct = false;         
    
      
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }
    }


 

    var imgx = null;

    if(cn == "incorrent" && req=='1')
    {
        imgx = <img  className="input_status" src={input_error} />
    }

    
    if(cn == "corrent" && req=='1')
    {
        imgx = <img className="input_status" src={input_check} />
    }

    useEffect(() => {

        if(val != props.value) //aktualizuj jesli sie zmieni..
        {
            setVal(props.value);
            setClassName('');
            setOnShow(false);
        }

        if( onShow == false && props.valChange != null && props.valChange != undefined ) //sprawdz czy dane sa poprawne i wyslij wyzej
        {
             var correct = true;
             if(cn == "incorrent" ) correct = false;                 
             setOnShow(true);
             props.valChange(props.name, val, correct,'');
    
        }
    })


    var err = "";
    if(props.err != undefined  &&  props.err != null ) 
    {       
        if(props.err[props.name] != null  && props.err[props.name] != undefined    ) err = props.err[props.name]['param'];
    }  



    var cnX = cn;
    if( val != null && val.length < 1 && cnX == 'corrent')
        {
            cnX = '';
        }


    return <fieldset>
           <input type="date" data-date-format="YYYY-MM-DD" value={val} onChange={checkAndChange} onKeyDown={onKeyDown} name={props.name} placeholder={props.placeholder} className={props.className + "   " + cnX} />        
 
             {imgx}
             <br/>
             <span className="form_err">{err + " "} &nbsp; </span>
           </fieldset>
}


export default InputDate;